// src/pages/education/Educations.js
import React from "react";
import "./Educations.css";
import DegreeCard from "../../components/degreeCard/DegreeCard";
import { degrees } from "../../portfolio";
import { Fade } from "react-reveal";
import { useTranslation } from "react-i18next";

function Educations({ theme }) {
  const { t } = useTranslation();

  return (
    <div className="main" id="educations">
      <div className="educations-header-div">
        <Fade bottom duration={2000} distance="20px">
          <h1 className="educations-header" style={{ color: theme.text }}>
            {t("education.pageTitle")}
          </h1>
        </Fade>
      </div>
      <div className="educations-body-div">
        {degrees.degrees.map((degree, index) => (
          <DegreeCard
            key={index}
            degree={degree}
            theme={theme}
            t={t} // ← Passez la fonction t au composant enfant
          />
        ))}
      </div>
    </div>
  );
}

export default Educations;